import React from 'react';
import { Modal } from 'ui-kit';
import './HospitableIntroModal.scss';
import LogoLinks, { Integrations } from 'components/Dashboard/Share/LogoLinks';

export interface IHospitableIntroModalProps {
  isOpen: boolean;
  onCancel: () => void;
}

export default function HospitableIntroModal({ isOpen, onCancel }: IHospitableIntroModalProps) {
  return (
    <Modal
      visible={isOpen}
      onCancel={onCancel}
      title={'Your stores are ready!'}
      className="HospitableIntroModal"
      width={650}
      footer={null}
    >
      <p>Next steps:</p>
      <ol className="action-list">
        <li>Modify stores to reflect your prices and add any products.</li>
        <li>Click share in the upper right corner of your store.</li>
        <li>Copy store link and click Hospitable icon to open your automated messaging.</li>
      </ol>

      <LogoLinks highlightIntegration={Integrations.hospitable} />
    </Modal>
  );
}
